import { NAV_ITEMS } from "@/constants/navigation";

interface NavLinksProps {
  transparent?: boolean;
  variant?: "desktop" | "mobile";
  onItemClick?: () => void;
}

export const NavLinks = ({
  transparent = false,
  variant = "desktop",
  onItemClick,
}: NavLinksProps) => {
  if (variant === "mobile") {
    return (
      <nav className="flex flex-col p-4 gap-1">
        {NAV_ITEMS.map((item) => (
          <a
            key={item.label}
            href={item.href}
            onClick={onItemClick}
            className="text-base font-medium hover:bg-muted rounded-xl px-5 py-4 transition-colors min-h-[48px] flex items-center"
          >
            {item.label}
          </a>
        ))}
      </nav>
    );
  }

  return (
    <nav className="hidden md:flex items-center gap-1">
      {NAV_ITEMS.map((item) => (
        <a
          key={item.label}
          href={item.href}
          className={`text-sm font-medium rounded-full px-5 py-3 transition-all min-h-[44px] flex items-center ${
            transparent 
              ? "text-white hover:bg-white/10" 
              : "hover:bg-muted"
          }`}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
};
